import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLinkInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M35.7 22.6q4.026 0 6.863 2.836 2.838 2.838 2.837 6.864t-2.837 6.863Q39.726 42 35.7 42t-6.863-2.837Q26 36.325 26 32.3t2.837-6.863q2.838-2.838 6.863-2.837m-1 15.7h2v-8h-2zm1-12q-.4 0-.7.3t-.3.7.3.7.7.3.7-.3.3-.7-.3-.7a.96.96 0 0 0-.7-.3M22 17.8h-8c-3.42 0-6.2 2.78-6.2 6.2s2.78 6.2 6.2 6.2h8V34h-8C8.48 34 4 29.52 4 24s4.48-10 10-10h8z" }), /* @__PURE__ */ _jsx("path", { d: "M28.274 22a12.8 12.8 0 0 0-3.6 4H16v-4zM34 14c5.047 0 9.221 3.745 9.9 8.606a12.66 12.66 0 0 0-5.206-2.65A6.19 6.19 0 0 0 34 17.8h-8V14z" })]
});
export default SvgLinkInfo;
